import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy, useRowSelect, UseFiltersOptions } from "react-table";
// import "assets/scss/TableHistorialDesvinculacion.scss"
import { Table, Container, Row, Col, Button } from 'reactstrap';
import { CertificadoDescarga, ESTADO_NO_ATENDIDA, functionFormatISODate } from "../../UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados";
import { GlobalFilter } from "../../UsuarioGeneral/Solicitud Certificados/GlobalFilter";
import { DataSolicitudesCeritificadosTable, DatosSolicitudXML } from './AnalistaAdministraSolicitudesCertificados';
import SelectItem from 'components/Varios/select';
import ButtonDownloadReportTable from 'components/Varios/ButtonDownloadReportTable';
import { Checkbox } from 'components/Varios/CheckBoxTable';
import { classNameIconoBasura } from 'constants/Icons-Font-Awesome';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

type selecttype = {
  label: string,
  value: string
}

type propsTableDirectorTHCertificados = {
  dataprops: DataSolicitudesCeritificadosTable[],
  onClickFirmarCertificado: (value: CertificadoDescarga) => void,
  onClickReversarEmisionCertificado: (value: CertificadoDescarga) => void,
  onClickFirmarCertificadosSeleccionados: (certificadosSeleccionados: CertificadoDescarga[]) => void,
  handleDescargarCertificado: (referenciaCertificado: string) => void,
  anioSeleccionado: number,
  onChangeYear: (anioSeleccionado: number) => Promise<void>
}

// { dataprops, onClickFirmarCertificado,onClickReversarEmisionCertificado, onClickFirmarCertificadosSeleccionados, handleDescargarCertificado, anioSeleccionado, onChangeYear }

const TableDirectorTHCertificados = (props: propsTableDirectorTHCertificados) => {

  const {
    dataprops,
    onClickFirmarCertificado,
    onClickReversarEmisionCertificado,
    onClickFirmarCertificadosSeleccionados,
    handleDescargarCertificado,
    anioSeleccionado,
    onChangeYear
  } = props;


  const [valoresColSelect, setvaloresColSelect] = useState<selecttype[]>([])
  const [valoresActualesColSelect, setvaloresActualesColSelect] = useState<selecttype[]>([])
  const [actualizaMulti, setactualizaMulti] = useState<number>(-1)
  const [diferencia, setdiferencia] = useState<selecttype>()
  const [botonFirmaMasivaCertificados, setbotonFirmaMasivaCertificados] = useState<HTMLElement>()

  const data = React.useMemo(
    () => [...dataprops], [dataprops]
  )

  function generarCellAcciones(valueCellAcciones: CertificadoDescarga | undefined) {

    if (!valueCellAcciones) {
      return <div>("No es posible realizar acciones sin un archivo")</div>;
    }

    const value = valueCellAcciones;

    const estilosIconosAcciones: React.CSSProperties = { backgroundColor: "#FFC200", float: "none", height: "27px", width: "27px" };


    const buttoncellAcciones = (
      <>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px"
        }}>

          <Button
            data-toggle="tooltip" data-placement="top" title="Firmar Certificado"
            style={estilosIconosAcciones}
            className="m-0 p-1 btn-icono"
            onClick={() => onClickFirmarCertificado(value)}
          >
            <i className="fas fa-eye" aria-hidden="true" ></i>
          </Button>
          <Button
            data-toggle="tooltip" data-placement="top" title="Reversar Certificado"
            style={estilosIconosAcciones}
            className="m-0 p-1 btn-icono"
            onClick={() => onClickReversarEmisionCertificado(value)}
          >
            <i className={`${classNameIconoBasura}`} aria-hidden="true" ></i>
          </Button>
        </div>


        {/* <Row className="justify-content-center rowAccionesFirmaCertificado">
          <Col md={3}>
           
          </Col>
          <Col md={3}>
            
          </Col>
        </Row> */}
      </>

    );


    if (value.idcertificado && value.estadocertificado && (value.certificadoAutomatizado || (!value.certificadoAutomatizado && value.referencia))) {
      if (value.estadocertificado === "G") {
        return (buttoncellAcciones)
      }
      else if (value.estadocertificado === "F") {
        return (
          <i
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Descargar Certificado"
            onClick={() => handleDescargarCertificado(value.referencia ?? "")}
            className="fas fa-download download"
            aria-hidden="true">
          </i>
        )

      }
    }
    else if (value.estadoSolicitud === "NA" && value.referencia === null) {

      return <div>La solicitud de certificado ha sido procesada</div>
    }
    else {
      return <div>No es posible realizar acciones sin un archivo</div>
    }
    return <></>
  }

  function generarCellDatosInformacionSolicitud(valueCellDatos) {
    const value = valueCellDatos
    if (value) {
      var datos: DatosSolicitudXML = value;
      return (
        <div>
          {
            datos && datos.usarTodosLosAnios &&
            <div>Se deben reflejar todos los años en este certificado </div>
          }
          {
            datos && !datos.usarTodosLosAnios && datos.anioHasta !== undefined && datos.anioHasta > 0 &&
            <div>

              <label>
                Fecha Desde :{datos.anioDesde}
              </label>
              <label>
                Fecha Hasta :{datos.anioHasta}
              </label>
            </div>
          }
          {
            datos && !datos.usarTodosLosAnios && datos.anioHasta !== undefined && !(datos.anioHasta > 0) &&
            <label>
              Año deseado para el certificado : {datos.anioDesde}
            </label>
          }
          {
            datos.terminoAcademico && datos.terminoAcademico !== '' &&
            <div>
              <label>
                Termino académico deseado : {datos.terminoAcademico}
              </label>
            </div>
          }
          {
            datos.incluirTipoContrato &&
            <div>
              <label>Año Inicio : {datos.anioInicio}</label> <br />
              <label>Año Fin : {datos.anioInicio}</label>
              <label>Incluir tipo contrato : {datos.incluirTipoContrato === true ? 'Si' : 'No'} </label>
            </div>
          }

        </div>
      )
    }
    else {
      return <div></div>
    }
  }

  type typeColumna = Column<DataSolicitudesCeritificadosTable> & UseFiltersOptions<DataSolicitudesCeritificadosTable>

  const columns_usando = React.useMemo<readonly typeColumna[]>(
    () => [
      {
        Header: '#',
        accessor: (originalrow, index) => index + 1,
        disableSortBy: true,
      },

      {
        Header: 'F. Solicitud',
        accessor: 'fecs',
        Cell: ({ value }) => {
          var algo = value ? functionFormatISODate(value.toString()) : "";
          return <div>{algo}</div>;
        }
      },

      {
        Header: "Ident.",
        accessor: "numeroIdentificacion"
      },
      {
        Header: 'Solicitante',
        accessor: 'nom',
      },
      {
        Header: 'Tipo Certificado',
        accessor: 'tip',
      },
      {
        Header: 'Dirigido a',
        accessor: 'dir'
      },
      {
        Header: 'Observaciones',
        accessor: 'obs',

      },
      {
        Header: 'Emitido por',
        accessor: 'analista'
      },
      {
        Header: 'F. Emisión',
        accessor: "fechaanalistaemite",
        Cell: ({ value }) => {
          var algo = value ? functionFormatISODate(value.toString()) : "";
          return <div>{algo}</div>;
        }
      },
      {
        Header: 'Datos',
        accessor: 'datossol',
        Cell: ({ value }) => {
          return generarCellDatosInformacionSolicitud(value)
        }
      },
      {
        Header: 'F. Firma',
        accessor: 'fechafirma',
        Cell: (s) => {
          var algo = s.value ? functionFormatISODate(s.value.toString()) : "";
          return <div>{algo}</div>;
        }
      },
      {
        Header: 'Estado Certificado',
        accessor: 'estc',

      },
      {
        Header: 'Acciones',
        accessor: 'cert',
        Cell: ({ value }) => {
          { return generarCellAcciones(value) }
        }
      }

    ],
    [data]
  )


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    selectedFlatRows,
    visibleColumns,
    prepareRow,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
    getToggleAllPageRowsSelectedProps,
    state,
    setGlobalFilter,

  } = useTable(
    {
      columns: columns_usando,
      data
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: 'selection',
            Header: ({ getToggleAllPageRowsSelectedProps }) => (
              <Checkbox
                isHeader={true}
                {...getToggleAllPageRowsSelectedProps()}
              />
            ),
            Cell: ({ row }) => (
              <Checkbox
                data={row.original}
                {...row.getToggleRowSelectedProps()}
              />
            )

          },
          ...columns
        ]
      })
    }

  )
  const sizerows = data.length;


  const { globalFilter, pageIndex, pageSize, selectedRowIds } = state;

  useEffect(() => {
    if (allColumns.length > 0) {
      var opcionesSelect: selecttype[] = []
      allColumns.map((columns, index) => {
        if (columns.id != "selection") {
          opcionesSelect.push({ label: columns.Header as string, value: index.toString() })
        }
      })
      setvaloresColSelect(opcionesSelect)
      setvaloresActualesColSelect(opcionesSelect)
    }
  }, [allColumns])


  function HandleStyle(header: string) {
    var s_border = 'solid 1px black'
    var s_background = '#243165'
    var s_color = "white"
    var s_width = "auto"

    switch (header) {
      case "#":
        s_width = "50px";
        break;
      case "Observaciones":
        s_width = "250px";
        break;
      default:
        break;
    }

    const estilos: React.CSSProperties = {
      border: s_border,
      background: s_background,
      color: s_color,
      textAlign: "center",
      wordBreak: "break-word",
      width: s_width
    }
    return (estilos)
  }

  function handleChangeMultiCols(selectedValues: selecttype[], anterioresValues: selecttype[]) {

    if (!selectedValues) {
      return
    }

    var orderedSelectedValues = [...selectedValues].sort((a, b) => (+a.value) - (+b.value))
    setvaloresActualesColSelect(orderedSelectedValues)

    var diferencia: selecttype | undefined = undefined;
    if (anterioresValues.length > selectedValues.length) {
      diferencia = anterioresValues.find(x => !selectedValues.includes(x))
    }
    else {
      diferencia = selectedValues.find(x => !anterioresValues.includes(x))

    }
    if (diferencia) {
      setdiferencia(diferencia)
    }
    setactualizaMulti(actualizaMulti + 1)

  }

  useEffect(() => {
    if (diferencia && actualizaMulti > -1) {
      var columna = allColumns.find((c) => c.Header === diferencia.label)
      if (columna) {
        if (typeof (columna.toggleHidden) === "function") {
          if (columna.isVisible) {
            columna.toggleHidden(true)

          }
          else {
            columna.toggleHidden(false)
          }
        }
      }
    }
  }, [actualizaMulti, valoresActualesColSelect, diferencia])


  const helperClassNamesWidthTable = useCallback(() => {
    const numberVisibleColumns = visibleColumns.length;
    const numeroSmall = 8
    const numeroExtraSmall = 6

    var classNameUsando = "tableHistorialDesvinculacion";
    if (numberVisibleColumns && numberVisibleColumns <= numeroExtraSmall) {
      classNameUsando = "tableHistorialDesvinculacion-xs";

    }
    else if (numberVisibleColumns && numberVisibleColumns > numeroExtraSmall && numberVisibleColumns <= numeroSmall) {
      classNameUsando = "tableHistorialDesvinculacion-sm";
    }
    else if (numberVisibleColumns && numberVisibleColumns > numeroSmall) {
      classNameUsando = "tableHistorialDesvinculacion-lg";

    }
    return classNameUsando;
  },
    [visibleColumns]
  )

  const ButtonFirmarMasivo = (certificadosSeleccionados: Array<CertificadoDescarga>) => {
    return (
      <Button
        className="btnFirmaMasiva"
        onClick={() => onClickFirmarCertificadosSeleccionados(certificadosSeleccionados)}
      >
        Firmar Certificados Seleccionados
      </Button>
    )
  }

  useEffect(() => {
    var boton: any = undefined
    if (selectedFlatRows.length > 0) {
      var certificadosSeleccionados: CertificadoDescarga[] = []
      selectedFlatRows.map((rows) => {
        if (rows.original.cert && rows.original.cert.estadocertificado === "G") {
          certificadosSeleccionados.push(rows.original.cert)
        }
      })

      boton = ButtonFirmarMasivo(certificadosSeleccionados);
    }
    setbotonFirmaMasivaCertificados(boton);
  }, [selectedFlatRows])



  const BotonDescargarReporte = useMemo(
    () => {
      var anioForButton = 0;
      if (anioSeleccionado >= 0) {
        anioForButton = +anioSeleccionado
      }
      return (
        <ButtonDownloadReportTable
          api='SolicitudCertificados/Analista/ReporteSolicitudesCertificados/D'
          nombreBoton='Reporte Solicitudes Certificados'
          apiYears='SolicitudCertificados/Analista/YearsSolicitudes'
          onChangeYear={onChangeYear}
          yearElegido={anioSeleccionado}
          opcionTodos={false}
        />
      )
    }, [anioSeleccionado])

  if (visibleColumns.length > 0) {
    return (
      <React.Fragment>

        <Container className='parentTableHistorial'>
          {
            valoresColSelect.length > 0 &&
            <Row>
              <Col xl={12}>
                <SelectItem
                  options={valoresColSelect}
                  value={valoresActualesColSelect}
                  onChange={(values: any) => handleChangeMultiCols(values, valoresActualesColSelect)}
                  placeholder=""
                  name="columnastableselect"
                  id="columnastableselect"
                  icon="fa-caret-right"
                  isMulti={true}
                />
              </Col>
            </Row>
          }

          <Row className="mt-5 mt-md-3 ">
            <Col xl={{ offset: 9, size: 3 }} lg={{ offset: 8, size: 4 }} md={{ offset: 8, size: 4 }} sm={{ offset: 8, size: 4 }}   >
              <GlobalFilterTable
                filter={globalFilter}
                setFilter={setGlobalFilter}

              />
            </Col>
          </Row>


          <Row className="justify-content-end">
            <Col xl={3} lg={3} md={4} sm={12}>
              {/* <ButtonDownloadReportTable
                api='SolicitudCertificados/Analista/ReporteSolicitudesCertificados/D'
                nombreBoton='Reporte Solicitudes Certificados'
                apiYears='SolicitudCertificados/Analista/YearsSolicitudes'
              

              /> */}
              {BotonDescargarReporte}
            </Col>
          </Row>

          <Row className="justify-content-start">
            <Col xl={2} sm={12}>
              {botonFirmaMasivaCertificados}
            </Col>
          </Row>


          <Row>
            <Col xl={12}>
              <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className={`mt-3 ${helperClassNamesWidthTable()}`}>
                <thead>
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          style={HandleStyle(column.Header as string)}
                        >
                          {column.render('Header')}
                          <span>
                            {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row, indirow) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()}>

                        {row.cells.map(cell => {
                          if (cell.column.Header === '#') {
                            return (
                              <td
                                key="cell#TableSolicCertiEmitFir"
                                style={{
                                  border: 'solid 1px black',

                                }}
                              >{indirow + 1}</td>)
                          }
                          return (
                            <td
                              className={cell.column.Header === "Observaciones" ? 'tdjustify' : "tableHistorialcolumns"}
                              {...cell.getCellProps()}
                              style={{
                                border: 'solid 1px black',

                              }}
                            >
                              <div>
                                {cell.render('Cell')}

                              </div>
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              <div className="text-right filasinfopagination">
                <span>Mostrando {page.length} de {sizerows} filas</span>
              </div>
              <div className="containerPaginacionHistorial text-right">
                <span>
                  Página{' '}
                  <strong>
                    {pageIndex + 1} de {pageOptions.length}
                  </strong>{' '}
                </span>
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[5, 10, 15, 25, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize} >
                      Mostrar {pageSize}
                    </option>
                  ))}
                </select>
                <span className="container-btns-pagination">
                  <button className={canPreviousPage ? "btnAnteriorPaginacion" : "btndisabled"} onClick={() => previousPage()} disabled={!canPreviousPage}>Anterior</button>
                  <button className={canNextPage ? "btnSiguientePaginacion" : "btndisabled"} onClick={() => nextPage()} disabled={!canNextPage} >Siguiente</button>
                </span>
              </div>
            </Col>
          </Row>

        </Container>
      </React.Fragment>

    )
  }
  else {
    return (
      <React.Fragment>
        <Container className='parentTableHistorial'>
          {
            valoresColSelect.length > 0 &&
            <React.Fragment>
              <Row>
                <Col xl={12}>
                  <SelectItem
                    options={valoresColSelect}
                    value={valoresActualesColSelect}
                    onChange={(values: any) => handleChangeMultiCols(values, valoresActualesColSelect)}
                    placeholder=""
                    name="columnastableselect"
                    id="columnastableselect"
                    icon="fa-caret-right"
                    isMulti={true}
                  />
                </Col>
              </Row>



              <Row>
                <Col xl={12}>
                  <p>Ha ocultado toda la tabla. Muestre una columna para volver a verla.</p>
                </Col>
              </Row>
            </React.Fragment>

          }
        </Container>
      </React.Fragment>
    )
  }


}
export default TableDirectorTHCertificados;

